import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";

console.log("courtage");

gsap.registerPlugin(ScrollTrigger, MotionPathPlugin, DrawSVGPlugin);

document.addEventListener("DOMContentLoaded", (event) => {
	const pulses = gsap
		.timeline({
			ease: "elastic(2.5, 1)",
		})
		.from(
			".title-1",
			{
				color: "#D9E6F8",
			},
			0.1
		)
		.from(
			".title-2",
			{
				color: "#D9E6F8",
			},
			0.75
		)
		.from(
			".title-3",
			{
				color: "#D9E6F8",
			},
			1.75
		)
		.from(
			".title-4",
			{
				color: "#D9E6F8",
			},
			2.35
		)
		.from(
			".title-5",
			{
				color: "#D9E6F8",
			},
			3.2
		);

	const main = gsap
		.timeline({
			scrollTrigger: {
				trigger: ".scroll-section",
				scrub: 0.3,
				start: "top 50%",
				end: "bottom center",
			},
		})
		.from(".the-line", { drawSVG: 0, duration: 4, ease: "linear" }, 0)
		.add(pulses, 0);

	const mobileMain = gsap
		.timeline({
			scrollTrigger: {
				trigger: ".animated-line-mobile",
				scrub: 0.3,
				start: "top 60%",
				end: "bottom 60%",
			},
		})
		.from(".m-the-line", { drawSVG: 0, duration: 4, ease: "linear" }, 0);
});
